import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  authenticated: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, authenticated }) => {
  // 埋め込みモードかどうかをチェック
  const isEmbedded = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('embedded') === 'true' || 
           params.get('token') !== null || // トークンがある場合も埋め込みと判定
           window.parent !== window;
  };

  console.log('ProtectedRoute - authenticated:', authenticated, 'embedded:', isEmbedded());
  
  // 埋め込みモードの場合は認証をスキップ
  if (!authenticated && !isEmbedded()) {
    return <Navigate to="/auth" replace />;
  }
  
  return <>{children}</>;
};